import { render } from "./ParamsTab.vue?vue&type=template&id=043511f8"
import script from "./ParamsTab.vue?vue&type=script&lang=js"
export * from "./ParamsTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__